export function formatSharePercentage(value: number) {
  if (!Number.isFinite(value) || value <= 0) {
    return '0.0%'
  }

  if (value < 0.1) {
    return '< 0.1%'
  }

  if (value < 100 && Math.round(value * 10) / 10 >= 100) {
    return '> 99.9%'
  }

  return `${value.toFixed(1)}%`
}
